/**
 * Determines whether App Check debug tokens may be activated.
 * Under NO circumstances may a production build enable debug token behavior,
 * regardless of any legacy preview or debug flags.
 */
export const shouldEnableAppCheckDebugToken = (
  env: { PROD?: boolean; DEV?: boolean; VITE_APP_PREVIEW_MODE?: string } = import.meta.env,
): boolean => {
  if (env.PROD) return false
  return Boolean(env.DEV)
}
